const SearchDropdownIndicator = () => {
  // hide the dropdown arrow for the search select
  return null;
};
export default SearchDropdownIndicator;